// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"9e687901","213":"944b15ac","453":"07a6ab98","455":"5809052b"}[chunkId] + ".chunk.js";
};